// リリースフラグの種別・ラベル・説明文（client / admin 共通）
//
// 注: ここの型はバックエンドの `ReleaseFlagType` enum と同期する
// （backend/openapi/components/schemas/commons/release_flag.yaml）

/** リリースフラグの種別 */
export type ReleaseFlagType = 'settlement_statistics_converter' | 'general_chat' | 'memo';

/** 短い表示ラベル */
export const RELEASE_FLAG_LABELS: Record<ReleaseFlagType, string> = {
  settlement_statistics_converter: '決算統計コンバーター',
  general_chat: '汎用チャット',
  memo: 'メモ',
};

/** クライアントアプリでの挙動を示す説明文 */
export const RELEASE_FLAG_DESCRIPTIONS: Record<ReleaseFlagType, string> = {
  settlement_statistics_converter: '決算統計コンバーターの公開を制御',
  general_chat: '汎用チャット（AI業務アシスタント）の公開を制御',
  memo: 'メモ機能の公開を制御',
};
